import React, { useContext } from "react";
import { SiteStateContext } from "./SiteStateContext";

const StatusModule = () => {
  const { status, setStatus } = useContext(SiteStateContext);

  const handleStatusChange = (newStatus) => {
    setStatus(newStatus);
    // provider’s useEffect will handle localStorage syncing
  };

  return (
    <div style={styles.container}>
      <p style={styles.status}>{status}</p>
      <div style={styles.buttonGroup}>
        <button onClick={() => handleStatusChange("All Scans")} style={styles.button}>
          All
        </button>
        <button onClick={() => handleStatusChange("Team Scans")} style={styles.button}>
          Team
        </button>
        <button onClick={() => handleStatusChange("Private Scans")} style={styles.button}>
          Private
        </button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    color: "var(--theme-text-color)",
    padding: "1rem",
    borderRadius: "8px",
    textAlign: "center",
    maxWidth: "300px",
    margin: "1rem auto",
  },
  status: {
    fontWeight: "bold",
    marginBottom: "1rem",
  },
  buttonGroup: {
    display: "flex",
    justifyContent: "center",
    gap: "0.5rem",
  },
  button: {
    padding: "0.5rem 1rem",
    backgroundColor: "var(--theme-color)",
    border: "none",
    borderRadius: "4px",
    color: "var(--theme-text-color)",
    cursor: "pointer",
  },
};

export default StatusModule;
